var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-info"},[_c('div',[_vm._v("版权所有©清远市嘉兴医药有限公司")]),_c('div')]),_c('img',{staticClass:"footer-img",attrs:{"src":require("../../static/images/service.png"),"alt":"二维码图片"}})])
}]

export { render, staticRenderFns }